/**
 * Single source of truth for OpenRemit brand assets.
 * Every surface that renders the logo (app chrome, login, print templates)
 * imports from here so the mark can never drift between screens.
 */

/** Full horizontal lockup: globe mark + "OpenRemit" wordmark + tagline. */
export const OPENREMIT_LOGO_SRC =
  'https://cdn.magicpatterns.com/uploads/fMML7P541chUsBsgMLTadp/ChatGPT_Image_Sep_15,_2026,_01_43_11_PM.png'

/** Intrinsic aspect ratio (width / height) of the lockup, for reserving space. */
export const OPENREMIT_LOGO_RATIO = 3.14

export const OPENREMIT_LOGO_ALT = 'OpenRemit — Borders Made Simpler'

/** Brand colours sampled from the logo. */
export const BRAND_BLUE = '#1355A6'
export const BRAND_GOLD = '#F5C518'
